import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import React, { useEffect } from "react";
import SearchToolbar from "../toolbars/SearchToolbar";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useLayoutContext } from "@ntg/component-library/contexts";
import { useNavigate } from "react-router";
import { useSearchForManufacturingItems } from "../hooks/Manufacturing/useSearchForManufacturingItems";

export default function ManufacturingContainer() {
    const { SetPrimaryTitle, SetSecondaryHeader } = useLayoutContext();
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = React.useState<string>("");
    const { data: searchResults, isLoading } =
        useSearchForManufacturingItems(searchTerm);

    useEffect(() => {
        SetPrimaryTitle("Manufacturing Overview");
        SetSecondaryHeader(
            <SearchToolbar
                domain="Manufacturing"
                onSearch={(term) => setSearchTerm(term)}
            />,
        );
        return () => {
            SetPrimaryTitle("");
            SetSecondaryHeader(null);
            setSearchTerm("");
        };
    }, [SetPrimaryTitle, SetSecondaryHeader]);

    if (isLoading) return <p>Loading…</p>;

    return (
        <TableContainer component={Paper}>
            <Table className="foTable">
                <TableHead>
                    <TableRow>
                        <TableCell>Item</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Contact</TableCell>
                        <TableCell>Boat</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Date</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {searchResults?.map((item) => (
                        <TableRow key={item.orderItemID}>
                            <TableCell>
                                <Button
                                    color="primary"
                                    onClick={() => navigate(`/ManufacturingItem/${item.orderItemID}`)}
                                    size="small"
                                    variant="contained"
                                >
                                    {item.coOrderItemID}
                                </Button>
                            </TableCell>
                            <TableCell>{item.itemDescription}</TableCell>
                            <TableCell>{item.contact}</TableCell>
                            <TableCell>{item.boat}</TableCell>
                            <TableCell>{item.status}</TableCell>
                            <TableCell>
                                {item.date
                                    ? new Date(item.date).toLocaleDateString()
                                    : ""}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={6}>
                            {searchResults && searchResults.length ? (
                                <span>{searchResults.length}</span>
                            ) : (
                                <span>No</span>
                            )}{" "}
                            results
                        </TableCell>
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
}
